<script>
    export let lang = 'en';

    let input = '';
    let output = '';
    let image = false;
    // $: input, (output = caesarShift(input));

    const updateOutput = (e) => {
        if (e.charCode === 13) () => (output = caesarShift(input));
    };

    function caesarShift(str) {
        // Set the offsets
        let bg_offset = 15;
        let en_offset = 13;
        let num_offset = 5;

        // Make an output variable
        output = '';

        // Go through each character
        for (var i = 0; i < str.length; i++) {
            // Get the character we'll be appending
            var c = str[i];

            // LATIN LETTERS
            if (c.match(/[a-z]/i)) {
                // Get its code
                let code = str.charCodeAt(i);

                // Uppercase letters
                if (code >= 65 && code <= 90) {
                    c = String.fromCharCode(((code - 65 + en_offset) % 26) + 65);
                }

                // Lowercase letters
                else if (code >= 97 && code <= 122) {
                    c = String.fromCharCode(((code - 97 + en_offset) % 26) + 97);
                }
            }

            //NUMBERS
            if (c.match(/\d/i)) {
                // Get its code
                let code = str.charCodeAt(i);
                c = String.fromCharCode(((code - 48 + num_offset) % 10) + 48);
            }

            // CYRILLIC LETTERS
            // абвгдежзийклмнопрстуфхцчшщъьюя
            if (c.match(/[а-яА-Я]/i)) {
                // Get its code
                let code = str.charCodeAt(i);
                let specificOffset = 0;
                let alphabetOffset = 0;
                if ((code > 1086 && code <= 1103) || (code > 1054 && code <= 1071)) {
                    alphabetOffset = -30;
                    specificOffset = 0;
                }
                if ((code >= 1084 && code < 1087) || (code >= 1052 && code < 1055)) {
                    specificOffset = 1;
                }
                if (code == 1100 || code == 1068) {
                    specificOffset = -1;
                }
                if (code == 1085 || code == 1086 || code == 1053 || code == 1054) {
                    specificOffset = 2;
                }
                if (code == 1102 || code == 1103 || code == 1070 || code == 1071) {
                    specificOffset = -2;
                }

                c = String.fromCharCode(
                    code - 1024 + bg_offset + specificOffset + alphabetOffset + 1024
                );
            }

            // Append
            output += c;
        }

        // All done!
        image = true;
        setTimeout(function () {
            image = false;
        }, Math.floor(Math.random() * 2000));
        return output;
    }
</script>

<section
    class="grid w-full gap-4 px-0 py-32 text-lg font-light text-center text-white bg-blue-100 xl:px-40 md:px-20 sm:px-10 obelisk heading-margin"
    style="
background-image: url(/img/svg/zigzag.svg);
background-position: center;
background-size:cover;
background-repeat: no-repeat;"
>
    <img
        class="h-20 mb-10 lg:mb-20 place-self-center"
        src={lang === 'bg' ? '/img/svg/logo-bg.svg' : '/img/svg/logo-en.svg'}
        alt="Inner Voice"
    />

    <h2>{lang == 'bg' ? 'Закодиране' : 'Encrypt'}</h2>
    <p>
        {lang == 'bg'
            ? 'Използвай нашия енкодер, за да закодираш или разкодираш тайно послание.'
            : 'Use out encrypter to encode or decode a secret message.'}
    </p>

    <input
        type="text"
        bind:value={input}
        placeholder={lang == 'bg' ? 'Разкодирай / закодирай текст' : 'Decode / encode text'}
        class="w-full p-2 text-blue-100 place-self-center"
        on:keypress={updateOutput}
    />

    <button
        on:click={() => (output = caesarShift(input))}
        disabled={input.length > 0 ? false : true}
        class="px-4 py-2 mt-4 text-xl teal-button place-self-center"
    >
        {#if lang == 'bg'}
            Разкодирай / Закодирай
        {:else}
            Decode / Encode
        {/if}
    </button>
    <br /><br />
    {#if image}
        <img src="/img/gif/vg-icon.gif" alt="🗝️" class="h-10 place-self-center" />
    {:else}
        <h3 class="mx-8 text-center break-all max-width-full">{output}</h3>
    {/if}
</section>
